import {getArea} from '@apps-common/geocorn-sdk/geom/cea';

import formatNumber, {DEFAULT_FORMAT} from '../format-number/format-number.js';
import {
  acres,
  hectares,
  identity,
  squareFeet,
  squareKilometers,
  squareMiles,
  squareNauticalMiles,
} from '../conversions.js';
import {areaUnits} from '../../constants/index.js';

const conversionMap = {
  [areaUnits.metric.m2]: n => identity(n),
  [areaUnits.metric.km2]: n => squareKilometers(n),
  [areaUnits.metric.ha]: n => hectares(n),
  [areaUnits.usc.ft2]: n => squareFeet(n),
  [areaUnits.usc.mi2]: n => squareMiles(n),
  [areaUnits.usc.ac]: n => acres(n),
  [areaUnits.usc.nmi2]: n => squareNauticalMiles(n),
};

export const localizationMap = {
  [areaUnits.metric.m2]: 'common:unitFormat.squareMeters',
  [areaUnits.metric.km2]: 'common:unitFormat.squareKilometers',
  [areaUnits.metric.ha]: 'common:unitFormat.hectares',
  [areaUnits.usc.ft2]: 'common:unitFormat.squareFeet',
  [areaUnits.usc.mi2]: 'common:unitFormat.squareMiles',
  [areaUnits.usc.ac]: 'common:unitFormat.acres',
  [areaUnits.usc.nmi2]: 'common:unitFormat.squareNauticalMiles',
};

export const DEFAULT_AREA_FORMAT = '0,0.[000]';

export const formatArea = (
  squareMeters,
  unit = areaUnits.metric.m2,
  format = DEFAULT_AREA_FORMAT
) => {
  if (!conversionMap[unit]) {
    return '';
  }
  return formatNumber(squareMeters, conversionMap[unit], format);
};

export const formatPolygonArea = (
  polygon,
  unit = areaUnits.metric.m2,
  format = DEFAULT_FORMAT
) => {
  if (!conversionMap[unit]) {
    return '';
  }
  const squareMeters = getArea(polygon);
  return formatNumber(squareMeters, conversionMap[unit], format);
};

export default formatPolygonArea;
